import { z } from 'zod';

const percent = z.number().min(0).max(100);

/** Percent surcharges a catalog gives projects that set none of their own. */
export const priceSurchargesSchema = z.object({
  steelExtra: percent.optional(),
  foundations: percent.optional(),
  services: percent.optional(),
  fees: percent.optional(),
  range: z.number().min(0).max(50).optional(),
});

/** Unit prices in € (net) by cost item id; items left out keep the built-in guide price. */
export const catalogPricesSchema = z.record(z.string().max(40), z.number().min(0).max(1e7));

export const priceCatalogSchema = z.object({
  id: z.string(),
  name: z.string(),
  /** Country the prices are meant for. */
  country: z.enum(['de', 'pl']),
  /** Used by every project that has not chosen a catalog. */
  isDefault: z.boolean(),
  prices: catalogPricesSchema,
  surcharges: priceSurchargesSchema,
  updatedAt: z.string(),
});
export type PriceCatalog = z.infer<typeof priceCatalogSchema>;
export const priceCatalogListSchema = z.object({ catalogs: z.array(priceCatalogSchema) });

export const savePriceCatalogRequestSchema = z.object({
  name: z.string().trim().min(1).max(80),
  country: z.enum(['de', 'pl']),
  isDefault: z.boolean().optional(),
  prices: catalogPricesSchema,
  surcharges: priceSurchargesSchema,
});
export type SavePriceCatalogRequest = z.infer<typeof savePriceCatalogRequestSchema>;
